import { render, staticRenderFns } from "./CopyrightReportSection.vue?vue&type=template&id=6678dc5a&scoped=true&"
import script from "./CopyrightReportSection.vue?vue&type=script&lang=js&"
export * from "./CopyrightReportSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678dc5a",
  null
  
)

export default component.exports